import axios from "axios";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

const arReactivateService = {
  getReactivatedUser: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}user/getReactivateContractEmp`,
        data,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

   getReactivatedBulkUser: async (data) => {
    try {
      const response = await axios.post(
        `${API_ENDPOINT}user/getReactivateBulkContractEmp`,
        data,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateReactivatedUser: async (data) => {
    try {

      const response = await axios.post(
        `${API_ENDPOINT}user/updateReactivateContractorEmp`,
        data
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

    updateBulkReactivatedUser: async (data) => {
    try {

      const response = await axios.post(
        `${API_ENDPOINT}user/updateReactivateBulkContractorEmp`,
        data
      );

      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default arReactivateService;